import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PanditBookingImg from "../../assets/images/new/BookPujaOrder.png";
import eStoreImg from "../../assets/images/new/estoreOrder.png";
import DailyPandit from "../../assets/images/new/dailyPujaOrder.png";
import darshanImg from "../../assets/images/new/darshanBookingOrder.png";
import worshipImg from "../../assets/images/new/pujaAtTempleOrder.png";
import banner from '../../assets/images/new/orderPageBanner.png'
import pujaKitOrder from '../../assets/images/new/pujaKitOrder.png'
import prasadOrder from '../../assets/images/new/prasadOrder.png'
import { t } from "i18next";
import { LoaderContext } from "../../AuthContext/AuthContext";
const ServiceList = () => {
  const { selectedLanguageID } = useContext(LoaderContext);
  const [services, setServices] = useState(
    [
      {
        title: t("Pandit Booking"),
        route: "/my-order-puja-booking",
        img: PanditBookingImg,
      },
      {
        title: t("Daily Pandit (Puja)"),
        route: "/my-order-daily-Booking",
        img: DailyPandit,
      },

      {
        title: t("Remedy Puja"),
        route: "/remedy-puja-orders",
        img: darshanImg,
      },
      {
        title: t("Homam Puja"),
        route: "/homam-puja-orders",
        img: darshanImg,
      },
      { title: t("E-Store"), route: "/my-order", img: eStoreImg },

      {
        title: t("Darshan Booking"),
        route: "/my-order-darshan-Booking",
        img: darshanImg,
      },

      {
        title: t("Puja At Temple"),
        route: "/my-order-puja-At-Temple",
        img: worshipImg,
      },
      {
        title: t("Prasad"),
        route: "/prasad-order",
        img: prasadOrder,
      },
      {
        title: t("Puja Kit Subscription"),
        route: "/puja-kit-orders",
        img: pujaKitOrder,
      },
      {
        title: t("Ganapati Visarjan"),
        route: "/ganapati-visarjan-orders",
        img: pujaKitOrder,
      }
    ]
  )

  useEffect(() => {
    setServices(
      [
        {
          title: t("Pandit Booking"),
          route: "/my-order-puja-booking",
          img: PanditBookingImg,
        },
        {
          title: t("Daily Pandit (Puja)"),
          route: "/my-order-daily-Booking",
          img: DailyPandit,
        },

        { title: t("E-Store"), route: "/my-order", img: eStoreImg },
        {
          title: t("Remedy Puja"),
          route: "/my-order-remedy-Booking",
          img: darshanImg,
        },
        {
          title: t("Homam"),
          route: "/my-order-homam-Booking",
          img: darshanImg,
        },
        {
          title: t("Puja At Temple"),
          route: "/my-order-puja-At-Temple",
          img: worshipImg,
        },
        {
          title: t("Prasad"),
          route: "/prasad-order",
          img: prasadOrder,
        },
        {
          title: t("Puja Kit Subscription"),
          route: "/puja-kit-orders",
          img: pujaKitOrder,
        },
        {
          title: t("Ganapati Visarjan"),
          route: "/ganapati-visarjan-orders",
          img: pujaKitOrder,
        }
      ]
    )
  }, [selectedLanguageID])


  return (
    <>
      <section className="page-header">
        <div className="page-header__bg" style={{ backgroundImage: `url(${banner})` }}></div>
        <div className="container" >
          <h2 className="page-header__title bw-split-in-left">{t("My Orders")}</h2>
        </div>
      </section>
      <div className="container mt-4">

        <div className="row">
          {services.map((service, index) => (
            <div key={index} className="col-6 col-sm-6 col-md-3  mb-4">
              <div className="card text-center shadow-sm h-100">
                <div
                  className="card-body d-flex flex-column justify-content-start align-items-center"
                >
                  <img
                    src={service.img}
                    alt={service.title}
                    width={80}
                    height={80}
                    style={{ width: '60px', height: '60px' }}
                  />
                  <h5 className="card-title mt-3 text-center" style={{ textWrap: 'nowrap' }}>{service.title}</h5>
                  <Link
                    to={service.route}
                    style={{ padding: '5px 16px', fontSize: '14px' }}
                    className="Normal-app-btn mt-2"
                  >
                    {t("View Orders")}
                  </Link>
                </div>
              </div>
            </div>


          ))}
        </div>
      </div>
    </>

  );
};

export default ServiceList;
